<template>
  <span>
    <select v-if="displayType === 'form'" name="" class="form-control" v-bind:value="modelValue" v-on:change="onChange($event.target.value)">
      <slot></slot>
      <option v-for="sport in sportList" :value="sport.value" :selected="sport.value == defaultSport">
        {{sport.label}}
      </option>
    </select>
    <span v-if="displayType === 'label'">{{sportLabel}}</span>
  </span>
</template>

<script>
  import CommonDataService from '../endpoints/CommonDataService'
  export default {
    emits: ['update:modelValue','change','sport-selected'],

    name: 'sport-input',
    props: {
      modelValue: String,
      displayType: {
        type: String,
        default: 'form'
      },
      orgId: {
        type: Number
      },
      academicYear: {
        type: Number
      },
      sponsored: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        sportList: []
      }
    },
    computed: {
      defaultSport () {
        return this.modelValue
      },
      sportLabel: function () {
        if (this.sportList && this.sportList.length > 0) {
          let sport = this.sportList.find((el) => el.value === this.modelValue)
          if (sport) return sport.label
        }

        return ''
      }
    },
    methods: {
      loadSportList: function () {
        let self = this

        CommonDataService.loadSportList(this.orgId, this.academicYear, this.sponsored)
          .then(response => {
            self.sportList = response.data
          })
          .catch(error => {
            self.error = error.message
          })
      },
      onChange (value) {
        this.$emit('update:modelValue', value)
        this.$emit('change', value)

        // Emit the full sport object as a separate event
        const sport = this.sportList.find((el) => el.value === value)
        if (sport) {
          this.$emit('sport-selected', sport)
        }
      }
    },
    created () {
      this.loadSportList()
    }
  }
</script>
